import { createContext, useContext, useEffect, useReducer } from "react";

import axios from "../../api/axios";
import {
  LOADED,
  LOADING,
  STATUS_EXCUTED,
  STATUS_IN_PROGRESS,
  STATUS_NOT_LOADED,
} from "../../api/constant";
import {
  alertSuccess,
  alertWarning,
  showTypeErrorFetch,
} from "../../utilities/alerts.utilities";
import { useParams } from "react-router-dom";
import {
  handOutReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/handOutReducer";
const HandOutFormContext = createContext({});
const HandOutFormProvider = ({ children }) => {
  const { movement_id } = useParams();
  const [state, dispatch] = useReducer(handOutReducer, INITIAL_STATE);
  const {
    lookForCode,
    movement: { type, item_header_id, warehouse_id },
    item,
    items_consume: {
      items_consume,
    },
    inventory_item: {
      items
    },
    lotes_item: {
      lotes_item,
    },
    measures:{
      measures,
    }
  } = state;


  useEffect(() => {
    if (lookForCode.length > 4) {
      lookForItemByCode(lookForCode);
    } else {
      dispatch({ type: types.ITEMS_FOUND, payload: [] });
    }
  }, [lookForCode]);

  useEffect(() => {
    if (item_header_id) {
      loadItemsMovementsByHeaderId(item_header_id);
    }
  }, [item_header_id]);

  useEffect(() => {
    if (
      state.movement.movement_id &&
      state.movement.document.status === STATUS_NOT_LOADED
    ) {
      loadDocuments();
    }
  }, [state.movement.document.status, state.movement.movement_id]);
  useEffect(() => {
    if (
      state.movement.movement_id &&
      state.movement.observation.status === STATUS_NOT_LOADED
    ) {
      loadObservations();
    }
  }, [state.movement.observation.status, state.movement.movement_id]);
  useEffect(() => {
    if (movement_id) {
      axios()
        .get(`inventory/header_movement/${movement_id}`)
        .then(({ data }) => {
          dispatch({
            type: types.SET_PAYLOAD_MOVEMENT,
            payload: {
              ...state.movement,
              movement_id: data.id,
              status_id: data.status_id,
              warehouse_id: data.warehouse_id,
              type: data.type,
            },
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [movement_id]);

  useEffect(() => {
    if (state.movement.movement_id) {
      if (state.items_consume.status === STATUS_NOT_LOADED) {
        loadMeasures();
        axios()
      .get(`inventory/loadItemsMovementsOutManuallyByHeaderId/${state.movement.movement_id}`)
      .then(({ data }) => {
        dispatch({
          type: types.ITEMS_ADD,
          payload: data
        });
        
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
      } 
    }
  }, [state.movement.movement_id, state.items_consume]);



  const loadObservations = () => {
    if (state.movement.movement_id) {
      axios()
        .get(
          `inventory/header_movement/${state.movement.movement_id}/getObservations`
        )
        .then(({ data }) => {
          dispatch({
            type: types.OBSERVATIONS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const loadDocuments = () => {
    if (state.movement.movement_id) {
      axios()
        .get(
          `inventory/header_movement/${state.movement.movement_id}/documents`
        )
        .then(({ data }) => {
          dispatch({
            type: types.DOCUMENTS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const createHandOut = () => {
    axios()
      .post(`inventory/createHandOutManually`, {
        type,
        warehouse_id,
      })
      .then(({ data }) => {
        dispatch({
          type: types.CHANGE_INPUT_HAND_OUT_BY_OBJECT,
          payload: {
            status_id: data.status_id,
            movement_id: data.id,
            warehouse_id: data.warehouse_id,
            status: LOADED,
          },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const lookForHeaderItemByCode = (code) => {
    dispatch({ type: types.CHANGE_STATUS_LOOK_FOR_CODE, payload: LOADING });
    axios()
      .get(`inventory/getHeaderItemByLikeCode/${code}`)
      .then(({ data }) => {
        dispatch({ type: types.ITEMS_FOUND, payload: data });
      })
      .catch((e) => {
        dispatch({
          type: types.CHANGE_STATUS_LOOK_FOR_CODE,
          payload: STATUS_NOT_LOADED,
        });
        showTypeErrorFetch(e);
      });
  };

  const lookForItemByCode = (code) => {
    dispatch({ type: types.CHANGE_STATUS_LOOK_FOR_CODE, payload: LOADING });
    axios()
      .post(`inventory/getItemByLikeCode`,{code_name:code})
      .then(({ data }) => {
        dispatch({ type: types.ITEMS_FOUND, payload: data });
      })
      .catch((e) => {
        dispatch({
          type: types.CHANGE_STATUS_LOOK_FOR_CODE,
          payload: STATUS_NOT_LOADED,
        });
        showTypeErrorFetch(e);
      });
  };


  const addObservationToMovement = (text) => {
    if (state.movement.movement_id) {
      axios()
        .post(
          `inventory/header_movement/${state.movement.movement_id}/notificated`,
          {
            note: text,
          }
        )
        .then(({ data }) => {
          dispatch({ type: types.RELOAD_OBSERTATIONS });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const addDocumentsToMovement = async (pictures) => {
    for await (const document of pictures) {
      var formData = new FormData();
      formData.append("document", document);
      await axios()
        .post(
          `inventory/header_movement/${state.movement.movement_id}/documented`,
          formData
        )
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
    dispatch({ type: types.RELOAD_DOCUMENTS });
  };
  const loadItemsMovementsByHeaderId = (header_id) => {
    axios()
      .get(`inventory/getInventoryByItem/${header_id}`)
      .then(({ data }) => {
        dispatch({ type: types.LOAD_INVENTORY_ITEM, payload: { items: data } });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  

  const getLotesByItemHandOut = () => {
    axios()
      .post(`inventory/getLotesByItemHandOut/${state.movement.movement_id}`, {
        item_id: item.item_id,
        warehouse_out_id: state.movement.warehouse_id,
        warehouse_in_id: state.movement.warehouse_id,
      })
      .then(({ data }) => {
        dispatch({ type: types.LOAD_INVENTORY_LOTES_ITEM, payload: data });
        dispatch({ type: types.CHANGE_ITEM_SELECTED_LOTE, payload: {item_name: item.item_name, item_measure_name: item.item_measure_name, item_code: item.item_code} })
        dispatch({ type: types.REMOVE_ITEM_SEARCH })
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const getLotesByItemHandOutForClickLoteConsume = (item_id, item_lote_selected) => {
    axios()
      .post(`inventory/getLotesByItemHandOut/${state.movement.movement_id}`, {
        item_id: item_id,
        warehouse_out_id: state.movement.warehouse_id,
        warehouse_in_id: state.movement.warehouse_id,
      })
      .then(({ data }) => {
        dispatch({ type: types.LOAD_INVENTORY_LOTES_ITEM, payload: data });
        dispatch({ type: types.CHANGE_ITEM_SELECTED_LOTE, payload: {item_name: item_lote_selected.name_article, item_measure_name: item_lote_selected.measure_name_lote, item_code: item_lote_selected.code_article} })
        dispatch({ type: types.REMOVE_ITEM_SEARCH })
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const setConsume = (value, index) => {
    state.items_consume.items_consume[index].consume = value;
    dispatch({ type: types.FRESH_STATUS_ITEMS_CONSUME});
  };

  const setMeasureConsume = (value, index) => {
    state.items_consume.items_consume[index].measure_consume_id = value;
    dispatch({ type: types.FRESH_STATUS_ITEMS_CONSUME});
    consumeToMovementOutManually(index);
  };

  const addOutToMovementOutManually = (item_lote) => {
    axios()
      .post(`inventory/addOutToMovementOutManually/${state.movement.movement_id}`, {
        inventory_parent_lote: item_lote.inventory_parent_lote_id ? item_lote.inventory_parent_lote_id : item_lote.inventory_parent_lote,
        item_id: item_lote.item_id,
        lote: item_lote.lote,
        date_expired: item_lote.date_expired,
      })
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_ITEMS_HAND_OUT,
        });
        dispatch({ type: types.REMOVE_ITEM_SEARCH })
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const consumeToMovementOutManually = async(index_item_consume) => {
    const item_consume = state.items_consume.items_consume[index_item_consume];
    axios()
      .post(`inventory/consumeToMovementOutManually/${state.movement.movement_id}`, {
        consume: item_consume.consume,
        measure_consume_id: item_consume.measure_consume_id,
        item_id: item_consume.item_id,
        inventory_parent_lote: item_consume.inventory_parent_lote,
        warehouse_out_id: state.movement.warehouse_id,
        warehouse_in_id: state.movement.warehouse_id,
      })
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_ITEMS_HAND_OUT,
        });
        dispatch({ type: types.REMOVE_ITEM_SEARCH })
      })
      .catch((e) => {
        showTypeErrorFetch(e);
        dispatch({
          type: types.RELOAD_ITEMS_HAND_OUT,
        });
      });
  };

  const loadItemsMovementsOutManuallyByHeaderId = (header_id) => {
    axios()
      .get(`inventory/loadItemsMovementsOutManuallyByHeaderId/${header_id}`)
      .then(({ data }) => {
        dispatch({ type: types.LOAD_INVENTORY_ITEM, payload: { items: data } });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const loadTypesMeasuresForConsume = async (item_id)=>{
    return axios()
      .get(`inventory/getListMeasureTypeByItemId/${item_id}`)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  }

  const loadMeasures = async () => {
    return axios()
      .get(`inventory/getMeasures`)
      .then(({ data }) => {
        dispatch({
          type: types.LOAD_MEASURES,
          payload: data
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };


  const getInventoryItemIdHandOut = (test_detail) => {
    const {  abreviature, id } = test_detail;
    dispatch({
      type: types.SET_ITEM_SELECTED_OUT,
      payload: {
        abreviature,
        measure_id: "",
        test_detail_id: id,
        quantity_consume: test_detail.quantity * state.movement.quantity,
      },
    });
    axios()
      .get(
        `inventory/getInventoryItemIdHandOut/${state.movement.movement_id}/${id}`
      )
      .then(({ data }) => {
        dispatch({
          type: types.SET_PAYLOAD_INVENTORY_ITEM,
          payload: {
            ...state.inventory_item,
            items: data,
          },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const finishHandOut = ()=>{
    dispatch({
      type: types.SET_PAYLOAD_MOVEMENT,
      payload: {
        ...state.movement,
        status_id: STATUS_EXCUTED,
      },
    });
    axios()
      .put(`inventory/finishHandOut/${state.movement.movement_id}`)
      .then(({ data }) => {})
      .catch((e) => {
        dispatch({
          type: types.SET_PAYLOAD_MOVEMENT,
          payload: {
            ...state.movement,
            status_id: STATUS_IN_PROGRESS,
          },
        });
        showTypeErrorFetch(e);
        dispatch({
          type: types.RELOAD_STATUS_ITEMS_CONSUME
        });
      });
  }

  const deleteDetailMovementByHeader = (detail_id)=>{
    axios()
      .post(`inventory/deleteDetailMovementByHeader/${detail_id}`)
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_STATUS_ITEMS_CONSUME
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
        dispatch({
          type: types.RELOAD_STATUS_ITEMS_CONSUME
        });
      });
  }


  return (
    <HandOutFormContext.Provider
      value={[
        state,
        dispatch,
        {
          createHandOut,
          lookForHeaderItemByCode,
          addDocumentsToMovement,
          addObservationToMovement,
          lookForItemByCode,
          setConsume,
          setMeasureConsume,
          getInventoryItemIdHandOut,
          finishHandOut,
          getLotesByItemHandOut,
          addOutToMovementOutManually,
          loadTypesMeasuresForConsume,
          consumeToMovementOutManually,
          deleteDetailMovementByHeader,
          getLotesByItemHandOutForClickLoteConsume,
        },
      ]}
    >
      {children}
    </HandOutFormContext.Provider>
  );
};
const useHandOut = () => useContext(HandOutFormContext)[0];
const useDispatchHandOutForm = () => useContext(HandOutFormContext)[1];
const useActionsHandOut = () => useContext(HandOutFormContext)[2];

export {
  HandOutFormContext,
  useHandOut,
  useDispatchHandOutForm,
  useActionsHandOut,
};
export default HandOutFormProvider;
